module.exports = __webpack_public_path__ + "img/caret-right.64a20bc5.svg";